export enum zIndexGeneral {
  ContextMenu = 1300,
  ModalOverlay = 10000,
  PopperTooltip = 10002,
  OverlayLayer = 10,
}
